import { Component, Input,  OnInit  } from '@angular/core';
import { ScoreService } from '../../../services/scores.service';
//import { PostMedia } from '../../interfaces/post-media.interface'; // Adjust the path as needed
import *  as Classes from '../../../classes/models.classes'

@Component({
    selector: 'app-media-carousel',
    templateUrl: './media-carousel.component.html',
    styleUrls: ['./media-carousel.component.css']
})
export class MediaCarouselComponent implements OnInit {

    @Input() UserID: number;
    @Input() mediaItems: Classes.PostMedia[] = [];

    //private _mediaItems: Classes.PostMedia[] = [];

    //@Input() set mediaItems(value: Classes.PostMedia[]) {
    //    if (value) {
    //        this._mediaItems = value;
    //        console.log('Updated media items:', this._mediaItems);
    //    }
    //}
    //get mediaItems(): Classes.PostMedia[] {
    //    return this._mediaItems;
    //}

    @Input() responsiveOptions: any[] = [];

    //isAtStart = true;
    //isAtEnd = false;

    mediaUrls: any[] = [];  // This will include URLs, indexing, and any relevant flags
    activeIndex: number = 0;


    constructor(
        //public activeModal: NgbActiveModal,
        //private fb: FormBuilder,
        //    private scoreService: ScoreService


    ) { }

    ngOnInit(): void {
        //    this.updateScoreDescription('truth', this.truthScore);
        //console.log('Media Items:', this.mediaItems);

        //this.mediaItems.forEach((item, index) => {
        //    console.log(`Media Item ${index}:`, item); // Logs each item with derived fields
        //});

        this.mediaItems = this.mediaItems.map((item, index) => ({
            ...item,
            index,
        }));

        //console.log('Media Items:', this.mediaItems);

    }

    updateActiveIndex(event: any): void {
        this.activeIndex = event.page;
    //    this.isAtStart = activeIndex === 0;
    //    this.isAtEnd = activeIndex >= this.mediaItems.length - 2;
    }

    get isAtStart(): boolean {
        //console.log("isAtStart activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available

        if (this.activeIndex === 22 || this.activeIndex === 0) {
            return true;
        };
        return false;

    }

    get isAtEnd(): boolean {
        //console.log("isAtEnd mediaUrls.length: " + this.mediaUrls.length);  // Log the entire event to see what properties are available
        //console.log("isAtEnd activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available
        if (this.mediaItems.length === 2 && this.activeIndex === 0) {
            return true;
        }

        if (this.mediaItems.length === 3 && this.activeIndex === 32) {
            return true;
        }
        else if (this.mediaItems.length === 4 && this.activeIndex === 42) {
            return true;
        }
        return false;
    }

    getMediaUrl(item: Classes.PostMedia): string {

        let url = '';
        if (item.mediaSource === 'local') {
            url = `api/content/media?fileName=${item.fileName}&mimeType=${item.mimeType}&userID=${this.UserID}`;
        } else if (item.mediaSource === 'url') {
            url = item.mediaUrl;
        }
        //console.log('Generated Media URL:', url);
        return url;

    }

    onCarouselClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    togglePlay(index: number, event: MouseEvent): void {
        event.stopPropagation();
        // Ensure the index is within bounds of the mediaItems array
        if (index >= 0 && index < this.mediaItems.length) {
            // Access the main mediaItems array directly
            if (this.mediaItems[index].isTenor) {
                this.mediaItems[index] = {
                    ...this.mediaItems[index], // Spread to ensure immutability principles (if required)
                    isPlaying: !this.mediaItems[index].isPlaying, // Toggle the isPlaying property
                };

                // Optional: Debugging logs to verify the state change
            //    console.log(`Toggled isPlaying for index ${index}:`, this.mediaItems[index]);
            }

        //    else {
        //        console.log(`Item at index ${index} is not a Tenor item. No changes made.`);
            //    }

        }

    //    else {
    //        console.error(`Index ${index} is out of bounds for mediaItems.`);
        //    }

    }



}
